module.exports = __webpack_public_path__ + "media/images/lb/931-bb073cfa7d93b1d876056d4d19181f36.svg";